import { __ } from '@wordpress/i18n';

/**
 * sessions.js
 * Functionality for the filterable list of sessions on the Sessions event tab.
 */

/* eslint-disable camelcase */

import { toggleNoResults, serialize } from './filter-lists';

// Elements
const form = document.getElementById( 'sessions-form' );
const results = document.getElementById( 'sessions-form-results' );

// Data
let sessions = [];

/**
 * Filter the sessions and sections.
 * Handles the visibility of items and sections.
 *
 * @param {object} data The serialized form data.
 */
function filterCardsAndSections( data ) {
	// Get the data.
	const { session_type } = data;

	// Loop the sessions.
	sessions.forEach( session => {
		const typeMatches = '' === session_type || session.dataset.sessionType.includes( session_type );

		if ( typeMatches ) {
			session.removeAttribute( 'hidden' );
			session.parentElement.classList.remove( 'd-none' );
		} else {
			session.setAttribute( 'hidden', true );
			session.parentElement.classList.add( 'd-none' );
		}
	} );

	// Clean up sections
	const sections = Array.from( results.querySelectorAll( 'section' ) );
	let visibleSections = 0;

	sections.forEach( section => {
		const hasVisibleItems = Array.from( section.querySelectorAll( '.card.msr-session:not([hidden]' ) );

		if ( hasVisibleItems.length ) {
			section.removeAttribute( 'hidden' );

			// hasVisibleItems.length is the number of visible items in the section.
			// Otherwise, add the +1 to count the section itself.
			visibleSections += hasVisibleItems.length;
		} else {
			section.setAttribute( 'hidden', true );
		}
	} );

	// Update the aria-live text.
	const ariaLiveText = document.getElementById( 'sessions-form-results-count' );
	if ( ariaLiveText ) {
		ariaLiveText.textContent = __( `Filter returned ${visibleSections} results.`, 'ms-research' );
	}
}

/**
 * Add or remove the no results message.
 */
function updateNoResults() {
	const showNoResults = 0 === Array.from( results.querySelectorAll( 'section:not([hidden])' ) ).length;

	toggleNoResults( showNoResults, results );
}

/**
 * Handle form change.
 */
const handleFormChange = () => {
	const currentData = serialize( form );

	// Filter no matter what.
	// We'll need this if someone sorts so the data is always up to date.
	filterCardsAndSections( currentData );

	// Add or remove the no results message.
	updateNoResults( results );
};

/**
 * Bind events.
 */
const bind = () => {
	form.addEventListener( 'change', handleFormChange );
};

/**
 * Init.
 */
const init = () => {
	// No form? Bail.
	if ( !form ) {
		return;
	}

	const { ariaLabel } = results.dataset;

	// Set up data.
	sessions = Array.from( document.querySelectorAll( '.card.msr-session' ) );

	// Set up attributes.
	results.setAttribute( 'aria-label', ariaLabel );
	results.setAttribute( 'aria-live', 'polite' );
	results.setAttribute( 'role', 'region' );

	// Bind events.
	bind();
};

export default init;
